import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AdjustTechFeaturesService } from '../adjust-tech-features-service';
import type { TechFeature } from '../../types';
import { TechFeatureSubmitApi } from '@/infrastructure/api-functions/core-drafting-api/tech-feature-submit-api';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

@injectable()
export class AdjustTechFeaturesServiceImpl implements AdjustTechFeaturesService {
    constructor(
        @inject(TechFeatureSubmitApi)
        private readonly _techFeatureSubmitApi: TechFeatureSubmitApi,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    async adjust(techFeatures: TechFeature[]): Promise<void> {
        const taskId = this._currentTaskService.taskId;
        const data = await this._submitTechFeaturesRepository(taskId, techFeatures);
        return data;
    }

    private _submitTechFeaturesRepository(taskId: string, techFeatures: TechFeature[]): Promise<void> {
        return this._techFeatureSubmitApi.submitTechFeature({
            task_id: taskId,
            tech_features: techFeatures.map((feature) => ({
                ...feature.originData,
                selected: feature.selected,
                flagged: feature.flagged,
            })),
        });
    }
}
